import { render } from "./tab-menu.vue?vue&type=template&id=c00013ec&scoped=true&ts=true"
import script from "./tab-menu.vue?vue&type=script&lang=ts"
export * from "./tab-menu.vue?vue&type=script&lang=ts"

import "./tab-menu.vue?vue&type=style&index=0&id=c00013ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c00013ec"]])

export default __exports__